import React, { useEffect, useState } from 'react'

import { SigningTasks } from '@builddocs/feature-internal-sign'
import { AOSRType, SecondaryActType } from '@builddocs/filestore-api'
import { CommentsViewer } from '@builddocs/mui'
import { ActPdfViewer } from '@builddocs/shared/feature-pdf-viewer'
import { DocsTypes } from '@builddocs/shared/feature-pdf-viewer'

type OwnProps = {
  act: AOSRType | SecondaryActType
  isOpenComments: boolean
  isOpenSigning: boolean
  toReopenInspection: boolean
  canShowSigningActions: boolean
  rights: {
    canEdit: boolean
    canInspect: boolean
    canSendActToSigning: boolean
    canSignAct: boolean
  }
  onOffTools: (isSelected: boolean) => void
  onDeviate?: (
    body: Record<string, any>,
    additionalInfo: Record<string, any>,
    onSuccess: () => any,
  ) => void
}

const ApplicationContentInner = ({
  act,
  isOpenComments,
  isOpenSigning,
  toReopenInspection,
  canShowSigningActions,
  rights,
  onOffTools,
  onDeviate,
}: OwnProps) => {
  const [currentDoc, setCurrentDoc] = useState<DocsTypes | undefined>(act)
  const [isSelected, setIsSelected] = useState<boolean>(false)
  const [needUpdatePDF, setNeedUpdatePDF] = useState<boolean>(false)

  useEffect(() => {
    onOffTools(isSelected)
  }, [isSelected])

  if (!currentDoc) {
    return null
  }

  return (
    <ActPdfViewer
      act={act}
      commentContent={
        isOpenComments ? (
          <CommentsViewer
            showHistory
            closingId={act.closingId}
            commentEntity={currentDoc}
            onDeviate={onDeviate}
          />
        ) : undefined
      }
      forceUpdate={needUpdatePDF}
      isDrawerOpenInitial={true}
      signContent={
        isOpenSigning ? (
          <SigningTasks
            canShowSigningActions={canShowSigningActions}
            document={currentDoc}
            rights={rights}
            toReopenInspection={toReopenInspection}
            onUpdatePDF={() => {
              setNeedUpdatePDF(true)
              setNeedUpdatePDF(false)
            }}
          />
        ) : undefined
      }
      onChangeDoc={setCurrentDoc}
      onChangeRightDoc={doc => setIsSelected(!!doc)}
    />
  )
}

export const ApplicationContent = React.memo(ApplicationContentInner)
